import type { ExtensionConfig } from '@goto/shell'
import { getLocationPathname } from '../helpers/dom-helpers'
import { listUnguardedRoutes } from '../helpers/gtc-helpers'
import { getLaunchDarklyFlag } from '../helpers/shell-helpers'
import { LaunchDarklyVariations } from '../models/feature-flag.models'

/**
 * Extension config
 */
const extensionConfig: ExtensionConfig = {
  id: '@jive/web',
  get url() {
    const gtcVersion = getLaunchDarklyFlag(LaunchDarklyVariations.GTC_VERSION) ?? 'latest'
    return new URL(`/experiences/jiveweb/${gtcVersion}/extension.js`, location.origin)
  },
  prerequisites: {
    shellFlags: 'gtc-voice-call-system!=default',
  },
  unguardedRoutes: listUnguardedRoutes(getLocationPathname()),
}

export default extensionConfig
